import React, { useEffect, useState } from "react";
import { WC2026_KICKOFF } from "./TournamentBar";
import "./matchdayPill.scss";

const MS_PER_DAY = 86_400_000;

// Midnight (UTC) of the day a timestamp falls on, so the matchday number rolls
// over at the start of each tournament day rather than at the 19:00 kickoff time.
function startOfUtcDay(ms: number): number {
  const d = new Date(ms);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

// Which tournament day we're on, or null before the opening match. Day 1 is the
// kickoff day; each subsequent UTC day adds one.
function getMatchday(kickoff: Date): number | null {
  const now = Date.now();
  if (now < kickoff.getTime()) return null;
  const days = Math.floor(
    (startOfUtcDay(now) - startOfUtcDay(kickoff.getTime())) / MS_PER_DAY
  );
  return days + 1;
}

interface MatchdayPillProps {
  /** Tighter sizing for the mobile header (same "Matchday N" label). */
  compact?: boolean;
}

// Live status pill shown in place of the countdown once the tournament has begun.
// Self-contained like TournamentBar — derives the day from the hardcoded kickoff.
const MatchdayPill: React.FC<MatchdayPillProps> = ({ compact }) => {
  const [matchday, setMatchday] = useState<number | null>(() =>
    getMatchday(WC2026_KICKOFF)
  );

  useEffect(() => {
    // The day only changes at UTC midnight; a coarse minute tick is plenty.
    const id = setInterval(
      () => setMatchday(getMatchday(WC2026_KICKOFF)),
      60_000
    );
    return () => clearInterval(id);
  }, []);

  if (matchday === null) return null;

  return (
    <span className={`matchdayPill${compact ? " matchdayPill--compact" : ""}`}>
      <span className="matchdayPill__dot" />
      <span className="matchdayPill__text">Matchday {matchday}</span>
    </span>
  );
};

export default MatchdayPill;
